// Very heavily lifted/inspired by the i18next-pseudo package
// @link https://github.com/MattBoatman/i18next-pseudo
import { PostProcessorModule } from "i18next";

import { uglifiedAlphabet, vowels } from "./conts.ts";

type PseudoOptions = {
  languageToPseudo: string;
  letterMultiplier: number;
  repeatedLetters: string[];
  letters: Record<string, string>;
  enabled: boolean;
};

const defaultOptions: PseudoOptions = {
  languageToPseudo: "en",
  letterMultiplier: 2,
  repeatedLetters: vowels,
  letters: uglifiedAlphabet,
  enabled: true,
};

export const pseudo: PostProcessorModule = {
  type: "postProcessor",
  name: "Pseudo",
  process: (
    value: string,
    _key: string,
    options: PseudoOptions,
    translator: { language: string }
  ) => {
    options = { ...defaultOptions, ...options };

    if (
      (translator?.language &&
        options.languageToPseudo !== translator.language) ||
      !options.enabled
    ) {
      return value;
    }

    // A regex to catch any element that looks like HTML
    const componentStringRegex = /<[^>]+>/g;

    // a regex to catch any string between double curly braces
    const curlyBracesRegex = /{{[^}]+}}/g;

    const regexes = [componentStringRegex, curlyBracesRegex];

    const indeciesToSkip: number[][] = [];

    regexes.forEach((regex) => {
      value.match(regex)?.forEach((match) => {
        const startIndex = value.indexOf(match);

        const endIndex = startIndex + match.length - 1;
        indeciesToSkip.push([startIndex, endIndex]);
      });
    });

    const processedValue = value
      .split("")
      .map((letter, index) => {
        let skip = false;
        // if index is between the start and end of a indeciesToSkip value, return the letter
        for (let i = 0; i < indeciesToSkip.length; i++) {
          // if (index >= start && index <= end) {
          if (index >= indeciesToSkip[i][0] && index <= indeciesToSkip[i][1]) {
            skip = true;
            break;
          }
        }

        if (skip) {
          return letter;
        }

        return options.repeatedLetters.indexOf(letter) !== -1
          ? options.letters[letter].repeat(options.letterMultiplier)
          : options.letters[letter] || letter;
      })
      .join("");

    return processedValue;
  },
};
